import './post.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { motion } from 'framer-motion';

const posters = [
  {
    id: 1,
    title: 'Mouse',
    price: '$500',
    image: 'https://images.unsplash.com/photo-1623425484828-7eccb29713a7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fG1vdXNlJTIwdGVjaG5vbG9naWNhbHxlbnwwfHwwfHx8MA%3D%3D'
  },
  {
    id: 2,
    title: 'Iphone',
    price: '$1000',
    image: 'https://images.unsplash.com/photo-1726587912121-ea21fcc57ff8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aXBob25lJTIwMTZ8ZW58MHx8MHx8fDA%3D'
  },
  {
    id: 3,
    title: 'MacBook',
    price: '$2000',
    image: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8bWFjYm9va3xlbnwwfHwwfHx8MA%3D%3D'
  }
];

const Postcard = () => {
  return (
    <div className="container my-4">
      <h2 className="text-center fw-bold mb-4">Products</h2>
      <div className="row">
        {posters.map((poster, index) => (
          <motion.div
            key={poster.id}
            className="col-md-4 mb-4"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="card poster-card h-100 text-center">
              <img src={poster.image} alt={poster.title} className="card-img-top poster-image" />
              <div className="card-body">
                <h5 className="card-title">{poster.title}</h5>
                <p className="card-text price">{poster.price}</p>
                <button className="btn btn-dark">Add to cart</button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Postcard;

